<template>
  <div class="idle-view"></div>
</template>

<script>
import {mapGetters} from "vuex";
export default {
  name: 'IdleAmbition',
  components: {
  },
  computed: {
        ...mapGetters({
            ambitionIdle: 'ambition/idle'
        })
  },
  watch: {
        isAppIdle: {
            immediate: true,
            handler(newVal, oldVal) {
                this.$store.dispatch('global commit', { type: 'ambition/setIdle', payload: newVal });
            }
        },
        ambitionIdle: {
            immediate: true,
            handler(newVal, oldVal){
                if (newVal) {
                    document.body.style.filter = "blur(8px)"
                }
            }
        }
    },
}
</script>

<style>
    body {
        transition: ease-in-out filter 0.4s;
    }
</style>
